"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CheckCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "clip-rule": "evenodd", "d": "M12.12 1a11 11 0 100 22 11 11 0 000-22zm5.2 8.7a1 1 0 10-1.41-1.4l-5.3 5.29-2.29-2.3a1 1 0 00-1.41 1.42l3 3a1 1 0 001.41 0l6-6z", "fill-rule": "evenodd" } }] }, "name": "check-circle", "theme": "filled" };
exports.default = CheckCircleFilled;
